import React from 'react';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { SVG_COMPONENTS } from '@/assets/admin';
import { useMobileColors } from '@/constants/residents/mobile/color';
import { usePaymentColors } from '@/constants/residents/mobile/paymentColors';

/**
 * Shared icon components for payment screens
 * Centralized to avoid duplication across multiple files
 */
export const PaymentIcons = {
  ChevronLeft: () => {
    const C = useMobileColors();
    const Icon = SVG_COMPONENTS.CHEVRON_LEFT as any;
    if (!Icon) return null;
    return <Icon width={24} height={24} color={C.TEXT_PRIMARY} />;
  },

  Card: () => {
    const C = useMobileColors();
    const Icon = RESIDENTS_SVG_COMPONENTS.CREDIT_CARD as any;
    if (!Icon) return null;
    return <Icon width={24} height={24} color={C.BUTTON_PRIMARY} />;
  },

  Bank: () => {
    const C = useMobileColors();
    const Icon = RESIDENTS_SVG_COMPONENTS.BANK as any;
    if (!Icon) return null;
    return <Icon width={24} height={24} color={C.BUTTON_PRIMARY} />;
  },

  CardOutline: () => {
    const C = useMobileColors();
    const Icon = RESIDENTS_SVG_COMPONENTS.CREDIT_CARD as any;
    if (!Icon) return null;
    return <Icon width={64} height={64} color={C.TEXT_TERTIARY} />;
  },

  Trash: () => {
    const PC = usePaymentColors();
    const Icon = SVG_COMPONENTS.TRASH as any;
    if (!Icon) return null;
    return <Icon width={16} height={16} color={PC.ERROR_RED} />;
  },

  Check: () => {
    const C = useMobileColors();
    const Icon = RESIDENTS_SVG_COMPONENTS.CHECK as any;
    if (!Icon) return null;
    return <Icon width={20} height={20} color={C.BUTTON_PRIMARY} />;
  },

  Calendar: () => {
    const C = useMobileColors();
    const Icon = RESIDENTS_SVG_COMPONENTS.CALENDAR as any;
    if (!Icon) return null;
    return <Icon width={64} height={64} color={C.TEXT_TERTIARY} />;
  },
};
